import { useTheme } from '@emotion/react';
import Card from '../../shared/Card';
import Header from '../../shared/Header';
import { Stack } from '../../shared/layouts';
import { useMediaQuery } from '@dnhb/node_package';
import LonelyPlaceholder from '../../shared/LonelyPlaceholder';
import { useTranslation } from 'react-i18next';
import OverviewDetailRow from '../../shared/OverviewDetailRow';
import useIconLibrary from '../../../hooks/useIconLibrary';

const AddressSection = ({
  addressIndex,
  zipcode,
  housenumber,
  housenumber_addition,
  street,
  place,
}) => {
  const { t } = useTranslation();
  const { breakpoints } = useTheme();
  const isMinDesktop = useMediaQuery(
    `(min-width: ${breakpoints.ml ?? '56.25rem'})`
  );

  const { HouseIcon } = useIconLibrary();

  return (
    <>
      <Card fontSize={isMinDesktop ? 'm' : 's'}>
        <Stack space={isMinDesktop ? 'l' : 'm'}>
          <Header
            icon={<HouseIcon height="2rem" width="2rem" />}
            title={
              <span css={{ textTransform: 'capitalize' }}>
                {t('Onderpand {{index}}', { index: addressIndex + 1 })}
              </span>
            }
            variant="section"
            fontSize={isMinDesktop ? 'l' : 's'}
          />
          <Stack space={'none'} divider={'default'}>
            <OverviewDetailRow descriptor={t('Postcode')} value={zipcode} hideIfEmpty/>
            <OverviewDetailRow
              descriptor={t('Huisnummer')}
              value={housenumber}
              hideIfEmpty
            />
            <OverviewDetailRow
              descriptor={t('Toevoeging')}
              value={housenumber_addition}
              hideIfEmpty
            />
            <OverviewDetailRow descriptor={t('Straatnaam')} value={street} hideIfEmpty/>
            <OverviewDetailRow descriptor={t('Plaatsnaam')} value={place} hideIfEmpty/>
            <LonelyPlaceholder />
          </Stack>
        </Stack>
      </Card>
    </>
  );
};

export default AddressSection;
